package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.DiagnosisSettingType
import com.jingfangpai.common.orm.mapping.enums.DiagnosisSettingSex
import kotlin.collections.Set
import com.jingfangpai.common.orm.mapping.enums.DiagnosisSettingPersonType
import com.jingfangpai.common.data.type.BigDecimal
import com.jingfangpai.common.data.serializer.BigDecimalSerializer
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer
import com.jingfangpai.common.orm.mapping.enums.DiagnosisSettingStatus

@Serializable
open class DiagnosisSetting(var id: String? = null){
	var name: String? = null
	var type: DiagnosisSettingType? = null
	var sex: Set<DiagnosisSettingSex>? = null
	var personType: Set<DiagnosisSettingPersonType>? = null
	var ageFrom: Int? = null
	var ageTo: Int? = null
	@Serializable(with = BigDecimalSerializer::class)
	var bmiFrom: BigDecimal? = null
	@Serializable(with = BigDecimalSerializer::class)
	var bmiTo: BigDecimal? = null
	@Serializable(with = BigDecimalSerializer::class)
	var whtrFrom: BigDecimal? = null
	@Serializable(with = BigDecimalSerializer::class)
	var whtrTo: BigDecimal? = null
	var organizationId: String? = null
	var userId: String? = null
	var createdBy: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null
	var weight: Int? = null
	var status: DiagnosisSettingStatus? = null
	@Serializable(with = DateTimeSerializer::class)
	var modifiedOn: DateTime? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as DiagnosisSetting
		if (id != other.id) return false
		if (name != other.name) return false
		if (type != other.type) return false
		if (sex != other.sex) return false
		if (personType != other.personType) return false
		if (ageFrom != other.ageFrom) return false
		if (ageTo != other.ageTo) return false
		if (bmiFrom != other.bmiFrom) return false
		if (bmiTo != other.bmiTo) return false
		if (whtrFrom != other.whtrFrom) return false
		if (whtrTo != other.whtrTo) return false
		if (organizationId != other.organizationId) return false
		if (userId != other.userId) return false
		if (createdBy != other.createdBy) return false
		if (createdOn != other.createdOn) return false
		if (weight != other.weight) return false
		if (status != other.status) return false
		if (modifiedOn != other.modifiedOn) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (name?.hashCode() ?: 0)
		result = 31 * result + (type?.hashCode() ?: 0)
		result = 31 * result + (sex?.hashCode() ?: 0)
		result = 31 * result + (personType?.hashCode() ?: 0)
		result = 31 * result + (ageFrom?.hashCode() ?: 0)
		result = 31 * result + (ageTo?.hashCode() ?: 0)
		result = 31 * result + (bmiFrom?.hashCode() ?: 0)
		result = 31 * result + (bmiTo?.hashCode() ?: 0)
		result = 31 * result + (whtrFrom?.hashCode() ?: 0)
		result = 31 * result + (whtrTo?.hashCode() ?: 0)
		result = 31 * result + (organizationId?.hashCode() ?: 0)
		result = 31 * result + (userId?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		result = 31 * result + (weight?.hashCode() ?: 0)
		result = 31 * result + (status?.hashCode() ?: 0)
		result = 31 * result + (modifiedOn?.hashCode() ?: 0)
		return result
	}

}
